import React from "react"
import {
    Box,
    Card,
    CardContent,
    TextField,
    Typography,
    Button,
    Divider,
    Stack,
} from "@mui/material"
import { useCreateSportCertificateMutation } from "../Redux/actions/certificate.action"
import { updateFields, resetForm } from "../Redux/actions/formValue.action"
import { useSelector, useDispatch } from "react-redux"
import { Loader } from "../components/index"
import { toaster, Message } from "rsuite"
import _ from "lodash"

const SportCertificateForm = () => {
    const dispatch = useDispatch()
    const [generateSportCer, generateSportCerState] = useCreateSportCertificateMutation()

    const formValue = useSelector(state => state.form)
    const year = _.get(formValue, "state.year", "")
    const student_name = _.get(formValue, "state.student_name", "")
    const position = _.get(formValue, "state.position", "")
    const institution_name = _.get(formValue, "state.institution_name", "")
    const institution_address = _.get(formValue, "state.institution_address", "")
    const class_name = _.get(formValue, "state.class_name", "")


    React.useEffect(() => {
        if (generateSportCerState.isSuccess) {
            const blob = generateSportCerState.data

            const url = window.URL.createObjectURL(blob)

            const a = document.createElement("a")
            a.href = url
            a.download = "sports_certificate.pdf"
            document.body.appendChild(a)
            a.click()

            a.remove()
            window.URL.revokeObjectURL(url)
            generateSportCerState.reset()
            dispatch(resetForm())
        } else if (generateSportCerState.isError) {
            toaster.push(<Message type="error" >Error while create the School Leaving certificate,Please try again later!</Message>, { placement: "topCenter" })
            generateSportCerState.reset()
        }
    }, [generateSportCerState.status])
    const handleSubmit = () => {
        if (
            !student_name || !class_name || !position || !year ||
            !institution_name || !institution_address
        ) {
            toaster.push(<Message type="info">Please fill all fields value!</Message>, { placement: "topCenter" })
            return
        }
        const data = {
            student_name,
            school_name:institution_name,
            school_address:institution_address,
            class_name,
            position,
            year
        }
        generateSportCer(data)
    }

    return (
        <Box sx={{ maxWidth: 720, mx: "auto", mt: 5 }}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight={600}>
                        Sport's Certificate
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Enter student and school details carefully
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    <Stack spacing={2.5}>
                        <TextField
                            label="Student Name"
                            name="student_name"
                            fullWidth
                            value={student_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ student_name: val }))
                            }}
                        />
                        <TextField
                            label="Institution Name"
                            name="institution_name"
                            fullWidth
                            value={institution_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ institution_name: val }))
                            }}
                        />

                        <TextField
                            label="Institution Address"
                            name="institution_address"
                            multiline
                            rows={2}
                            fullWidth
                            value={institution_address}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ institution_address: val }))
                            }}
                        />

                        <TextField
                            label="Department/Class"
                            name="class_name"
                            placeholder="eg. Green House,Yellow House"
                            rows={2}
                            fullWidth
                            value={class_name}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ class_name: val }))
                            }}
                        />
                        <TextField
                            label="Sport Session"
                            name="year"
                            placeholder="eg.2026-2027"
                            fullWidth
                            value={year}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ year: val }))
                            }}
                        />
                        <TextField
                            label="Secure Position"
                            name="position"
                            placeholder="eg.1st Place – 100m Sprint"
                            fullWidth
                            value={position}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ position: val }))
                            }}
                        />
                    </Stack>

                    <Box sx={{ mt: 4, textAlign: "right" }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ px: 4 }}
                            onClick={handleSubmit}
                        >
                            Generate Certificate
                        </Button>
                    </Box>
                </CardContent>
            </Card>
            {
                (
                    generateSportCerState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    );
};

export default SportCertificateForm
